import client from "./client";

const CONFIGURATION_TYPE = "patient-registration";

export async function fetchSectionConfiguration(facilityId) {
  if (!facilityId) {
    throw new Error("Facility ID is required to load section configuration");
  }

  const data = await client.get("ipd_section_configuration/", {
    facility_id: facilityId,
    configuration_type: CONFIGURATION_TYPE,
  });

  return data?.configuration ?? data;
}
